import { useMutation, useQuery } from "@apollo/client";
import ReactTable from "react-table";
import { GET_MESSAGE_LIST } from "../queries";
import { Input, Row, Col } from "reactstrap";
import { useState, Fragment, useEffect } from "react";
import { parseArray } from "../helpers";
import {
  DELETE_CSO_WISH,
  DELETE_SUPPORTER_STATUS,
  // SUPPORTER_DELETE_MESSAGE,
} from "../mutations";
// import HomepageIcon from "../assets/icon/homepage.png";
import { Link } from "react-router-dom";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import styles from "../Table/index.module.scss";
import animationLogo from "../../../../assets/utils/images/animetion_logo.gif";
import { format } from "date-fns";
import DissolveBadge from "../../../../components/DissolveBadge";
import { CHECK_USER_STATUS } from "../../../../queries";
import { useUserEmail } from "../../../../Layout/AppMain/LoginStatusContext";

export const statusChipStyle = {
  面談予定: {
    backgroundColor: "#FFF09F",
    border: "1px solid #e4a400",
    color: "#E4A400",
  },
  問合せ中: {
    backgroundColor: "#FFD5D4",
    color: "#FF0000",
    border: "1px solid #FF0000",
  },
  面談終了: {
    backgroundColor: "#D6D6D6",
    color: "#495057",
    border: "1px solid #495057",
  },
  面談依頼中: {
    backgroundColor: "#BBFFAA6B",
    color: "#1D9200",
    border: "1px solid #1D9200",
  },
  連携中: {
    backgroundColor: "#75EBFF2B",
    color: "#44CAE1",
    border: "1px solid #44CAE1",
  },
  新着: {
    backgroundColor: "#D5D4FF",
    color: "#0500FF",
    border: "1px solid #0500FF",
  },
  default: {
    backgroundColor: "#FFF09F",
    color: "#E4A400",
    border: "1px solid #e4a400",
  },
};

const MessageList = (props) => {
  const { activeKey } = props;
  const {
    loading,
    data: rawData,
    error,
    refetch: refetchCsoList,
  } = useQuery(GET_MESSAGE_LIST);

  const [selectedOrg, setSelectedOrg] = useState(null);
  const [checkedOrgs, setCheckedOrgs] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [longestSDGs, setLongestSDGs] = useState(0);
  const data = rawData?.myCollaborationStatusesAsSupporter?.edges?.map(
    (edge) => {
      const length = parseArray(edge.node.cso.sdgsImages).filter(
        (v) => v !== ""
      ).length;
      if (length > longestSDGs) {
        setLongestSDGs(length);
      }
      return edge.node;
    }
  );
  const toggle = () => setDeleteModalOpen(!deleteModalOpen);

  const [
    deleteCsoWish,
    { data: deletedCsoWish, loading: loadingDeleteCsoWish },
  ] = useMutation(DELETE_CSO_WISH);
  const [
    deleteCollaborationStatus,
    {
      data: deletedCollaborationStatus,
      loading: loadingDeleteCollaborationStatus,
    },
  ] = useMutation(DELETE_SUPPORTER_STATUS);

  const handleCheckRow = (id) => {
    if (!id) return;
    if (checkedOrgs.includes(id))
      setCheckedOrgs(checkedOrgs.filter((orgId) => orgId !== id));
    else setCheckedOrgs([...checkedOrgs, id]);
  };

  const handleDeleteCsoWish = () => {
    deleteCollaborationStatus({
      variables: {
        supporterStatusId: selectedOrg.id,
      },
      onCompleted: () => {
        refetchCsoList();
      },
    });
    setSelectedOrg(null);
    setDeleteModalOpen(false);
  };

  useEffect(() => {
    localStorage.setItem("tabActive", activeKey);
  }, [activeKey]);

  const { data: checkUserStatus } = useQuery(CHECK_USER_STATUS, {
    variables: {
      email: useUserEmail(),
    },
  });

  const canEdit =
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "can_edit" ||
    checkUserStatus?.allUsers?.edges[0]?.node?.supporterRole === "CAN_EDIT";

  const partnershipTableColumns = [
    // {
    //   Header: "選択問合せ",
    //   accessor: "checkbox",
    //   width: 90,
    //   Cell: ({ row }) => {
    //     return (
    //       <div style={{ textAlign: "center", width: "70px" }}>
    //         <Input
    //           onChange={() => {
    //             handleCheckRow(row._original.id);
    //           }}
    //           checked={[...checkedOrgs].includes(row._original.id)}
    //           style={{ position: "relative", left: 10 }}
    //           type="checkbox"
    //         />
    //       </div>
    //     );
    //   },
    // },

    {
      Header: "組織名",
      accessor: "name",
      // width: 400,
      Cell: ({ row }) => {
        return (
          <Link
            to={`/dashboards/organization-partnership/message/${row._original.id}`}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            {row._original.cso.name}
            {row._original.cso.isDissolve && <DissolveBadge />}
          </Link>
        );
      },
    },
    {
      Header: "ステータス",
      accessor: "status",
      width: 300,
      Cell: ({ row }) => {
        const status = row._original.readableSupporterStatus;
        const hasNewMessage = row?._original?.supporterHasNewMessage;
        return (
          <div
            style={{
              ...(statusChipStyle[status] || statusChipStyle["default"]),
              fontSize: "9px",
              padding: "4px 7px",
              borderRadius: "18px",
              whiteSpace: "nowrap",
              margin: "auto",
              position: "relative",
            }}
          >
            {status}
            {hasNewMessage && (
              <div
                style={{
                  position: "absolute",
                  top: "-3px",
                  right: "0",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: "#FF0000",
                }}
              />
            )}
          </div>
        );
      },
    },
    {
      Header: "面談日時",
      accessor: "interview_date",
      width: 400,
      Cell: ({ row }) => {
        return (
          <>
            {row._original.interviewDetail !== null ? (
              <>
                <div
                  style={{
                    ...statusChipStyle["default"],
                    fontSize: "9px",
                    padding: "4px 7px",
                    borderRadius: "18px",
                    whiteSpace: "nowrap",
                    margin: "auto",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      marginRight: "8px",
                    }}
                  >
                    {format(
                      new Date(
                        row._original.interviewDetail?.decidedInterviewDate
                      ),
                      "yyyy年MM月dd日 HH:mm"
                    )}
                  </span>
                  <a
                    {...(row._original.interviewDetail?.url && {
                      href: row._original.interviewDetail?.url,
                    })}
                    target="__blank"
                  >
                    URL
                  </a>
                </div>
              </>
            ) : (
              <div
                style={{
                  textAlign: "center",
                  width: "100%",
                }}
              >
                -
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "組織情報",
      accessor: "org_info",
      width: 75,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "75px",
            }}
          >
            {row._original.cso.isPublic ? (
              <Link
                to={`/dashboards/plofile-organization/${row._original.cso.pk}`}
                target="_blank"
                rel="noreferrer"
              >
                <i
                  className="pe-7s-home"
                  style={{ fontSize: "20px", color: "#000" }}
                ></i>
              </Link>
            ) : (
              <div
                role="button"
                style={{
                  color: "#545cd8",
                }}
                onClick={() => {
                  alert("本組織の情報は非公開となっています");
                }}
              >
                <i
                  className="pe-7s-home"
                  style={{ fontSize: "20px", color: "#000" }}
                ></i>
              </div>
            )}
          </div>
        );
      },
    },
    {
      Header: "HP",
      accessor: "homepage",
      width: 75,
      Cell: ({ row }) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              width: "75px",
            }}
          >
            <a
              href={row._original.cso.homepage}
              target="_blank"
              rel="noreferrer"
            >
              <i
                className="pe-7s-link"
                style={{ fontSize: "20px", color: "#000" }}
              ></i>
            </a>
          </div>
        );
      },
    },
    {
      Header: "",
      width: 45,
      Cell: ({ row }) => {
        const { csoStatusIsDone = false } = row?._original;

        if (csoStatusIsDone) return <></>;
        return (
          <>
            {canEdit && (
              <button
                type="button"
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  width: "",
                  fontSize: "12px",
                }}
                onClick={() => {
                  setSelectedOrg(row._original);
                  setDeleteModalOpen(true);
                  // handleDeleteCsoWish(row._original.id);
                }}
              >
                &#x2715;
              </button>
            )}
          </>
        );
      },
    },
  ];
  console.log(data);

  return (
    <Fragment>
      <Row
        className="mt-3"
        style={{
          overflowX: "auto",
        }}
      >
        <Col xs={12}>
          <div
            style={{
              fontWeight: "bold",
              fontSize: "14px",
              marginBottom: "8px",
            }}
          >
            メッセージ一覧
          </div>
          {loading && (
            <div className="loading__wrapper">
              <img
                alt="logo"
                style={{ width: "80px", margin: "auto" }}
                src={animationLogo}
              ></img>
            </div>
          )}
          {!loading && data && !error && (
            <ReactTable
              loading={loading}
              defaultPageSize={data.length > 0 ? data.length : 10}
              showPagination={false}
              className="-striped -highlight"
              style={{ cursor: "pointer" }}
              data={data}
              columns={partnershipTableColumns}
            />
          )}
        </Col>
      </Row>
      {/* Modal Delete CSO Message */}
      <Modal
        isOpen={deleteModalOpen}
        toggle={toggle}
        backdropClassName={styles["reverted-backdrop"]}
        className={styles["modal-content"]}
      >
        <ModalHeader
          toggle={toggle}
          className={styles["modal-header"]}
        ></ModalHeader>
        <ModalBody
          style={{
            padding: "16px 40px 40px 40px",
          }}
        >
          <div
            style={{
              fontSize: "20px",
              fontWeight: "bold",
              textAlign: "center",
            }}
          >
            {`${selectedOrg?.cso?.name}を`}
            <br />
            メッセージ一覧から削除しますか？
          </div>
          <Button
            style={{
              width: "100%",
              backgroundColor: "#EB5757",
              border: "none",
              marginTop: "32px",
              padding: "13px 53px",
            }}
            onClick={handleDeleteCsoWish}
          >
            削除
          </Button>
        </ModalBody>
      </Modal>
    </Fragment>
  );
};

export default MessageList;
